import {Box} from "@mui/material";
import {ErrorAlert} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {SupportSettings, useTenantApi} from "../../api";
import {useReloadTenant, useTenantId} from "../../tenant";
import {SupportSettingsEditForm} from "./SupportSettingsEditForm";

export function TenantSupportSettings() {
	const tenantId = useTenantId();
	const {getTenantSupportSettings, updateTenantSupportSettings} = useTenantApi();
	const reloadTenant = useReloadTenant();
	const {loading, error, result} = useAsync(getTenantSupportSettings, [tenantId]);

	async function handleSave(supportSettings: SupportSettings) {
		await updateTenantSupportSettings(tenantId, supportSettings);
		await reloadTenant();
	}

	if (error) {
		return <ErrorAlert error={error} />;
	}

	return (
		<Box maxWidth="sm">
			<SupportSettingsEditForm loading={loading} onSave={handleSave} supportSettings={result} />
		</Box>
	);
}
